module.exports = __webpack_public_path__ + "img/channel-fbNoChannel.f43cfaa3.png";